import {
  Box,
  Calendar1Icon,
  ChartIcon,
  CrmIcon,
  Divider,
  Grid2,
  Switch,
  Tooltip,
  Typography,
  UserIcon,
} from "components";
import {
  HoldingDataInterface,
  PortfolioDetailsInterface,
} from "interfaces/Portfolio";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";
import { matchDate } from "utils/helpers";

interface Props {
  portfolioDetailData: PortfolioDetailsInterface;
  holdingSummaryDetails: HoldingDataInterface;
}

const PortfolioDetailsHeaderSection = (props: Props) => {
  const { portfolioDetailData, holdingSummaryDetails } = props;

  const dispatch = useAppDispatch();

  const userData = useAppSelector((state) => state?.user?.userData);
  const { portfolioTabs } = useAppSelector((state) => state?.app?.tab);

  // const tabs = [
  //   {
  //     label: "Holdings View",
  //     canAccess: true,
  //   },
  //   {
  //     label: "Admin View",
  //     canAccess: userData?.grantAccess,
  //   },
  // ];

  return (
    <Grid2
      container
      size={12}
      p={2}
      borderRadius={1}
      bgcolor={"var(--grey-bg-100)"}
    >
      <Grid2 size={4.5} container spacing={1}>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={"4px"}>
          <UserIcon color="var(--neutral-500)" />
          <Typography
            fontWeight={500}
            color="var(--neutral-500)"
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            Client Name:
            <Typography
              fontWeight={500}
              color={"var(--black)"}
              component={"span"}
            >
              {portfolioDetailData?.clientName}
            </Typography>
          </Typography>
        </Grid2>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={"4px"}>
          <ChartIcon color="var(--neutral-500)" />
          <Typography
            fontWeight={500}
            color="var(--neutral-500)"
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            Portfolio Name/Code:
            <Typography
              fontWeight={500}
              color={"var(--black)"}
              component={"span"}
            >
              {portfolioDetailData?.name} - {portfolioDetailData?.portfolioId}
            </Typography>
          </Typography>
        </Grid2>
      </Grid2>

      <Grid2
        container
        size={7.5}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        gap={2}
      >
        <Grid2
          display={"flex"}
          flexDirection={"column"}
          gap={1}
          justifyContent={"flex-end"}
        >
          <Typography
            fontWeight={500}
            color="var(--neutral-500)"
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            <CrmIcon color="var(--neutral-500)" />
            Family Name:
            <Typography
              fontWeight={500}
              color={"var(--black)"}
              component={"span"}
            >
              {portfolioDetailData?.familyName}
            </Typography>
          </Typography>
          <Typography
            fontWeight={500}
            color="var(--neutral-500)"
            display={"flex"}
            alignItems={"center"}
            gap={1}
          >
            <Calendar1Icon color="var(--neutral-500)" />
            Inception Date:
            <Typography
              fontWeight={500}
              color={"var(--black)"}
              component={"span"}
            >
              {matchDate(holdingSummaryDetails?.inceptionDate, "DD MMM YYYY")}
            </Typography>
          </Typography>
        </Grid2>
        {userData?.userRole === UserRoleTypes.advisor && (
          <>
            <Divider orientation="vertical" sx={{ height: "24px" }} />
            <Tooltip
              title="No Access to Admin View"
              disableHoverListener={userData?.grantAccess}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  opacity: userData?.grantAccess ? 1 : 0.5,
                }}
              >
                <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                  Holding View
                </Typography>
                <Switch
                  sx={{ margin: 0 }}
                  checked={portfolioTabs === 1}
                  onChange={(event) => {
                    const selectedTab = event.target.checked ? 1 : 0;
                    dispatch(
                      TAB({ tabKey: "portfolioTabs", tabValue: selectedTab }),
                    );
                    dispatch(
                      TAB({ tabKey: "portfolioExtendedViewTabs", tabValue: 1 }),
                    );
                  }}
                  disabled={!userData?.grantAccess}
                />
                <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                  Admin View
                </Typography>
              </Box>
            </Tooltip>

            {/* <Tabs
              className="light"
              variant="standard"
              TabIndicatorProps={{
                style: {
                  display: "none",
                },
              }}
              onChange={(e, val) => {
                dispatch(
                  TAB({ tabKey: "portfolioExtendedViewTabs", tabValue: 1 }),
                );
                dispatch(TAB({ tabKey: "portfolioTabs", tabValue: val }));
              }}
              value={portfolioTabs}
            >
              {tabs?.map((dataItem, index) => {
                return (
                  <Tab
                    key={dataItem.label}
                    value={index}
                    disabled={!dataItem.canAccess}
                    label={
                      <Box display={"flex"} gap={1}>
                        <Typography>{dataItem.label}</Typography>
                        {!dataItem.canAccess && (
                          <LockIcon width={16} height={16} />
                        )}
                      </Box>
                    }
                  />
                );
              })}
            </Tabs> */}
          </>
        )}
      </Grid2>
    </Grid2>
  );
};

export default PortfolioDetailsHeaderSection;
